'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _roles = require('config/permissions/roles');

var _systemMetrics = require('./system-metrics.component');

var _systemMetrics2 = _interopRequireDefault(_systemMetrics);

var _systemMetrics3 = require('./system-metrics.service');

var _systemMetrics4 = _interopRequireDefault(_systemMetrics3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.reports.systemMetrics', [_angularUiRouter2.default]).component('systemMetrics', _systemMetrics2.default).service('SystemMetricsService', _systemMetrics4.default).config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('systemMetrics', {
    parent: 'reports',
    url: '/system-metrics',
    component: 'systemMetrics',
    data: {
      permissions: {
        only: [_roles.SYS_ADMIN],
        redirectTo: 'dashboard'
      }
    }
  });
}).name;


// WEBPACK FOOTER //
// ./components/app/reports/system-metrics/system-metrics.module.js